import React from "react";
import NotAvailable from "@/Components/Site/NotAvailable";
import AvailableComponent from "@/Components/Site/AvailableComponent";
import "@/Scss/Site/Product/mainInfo.scss";

const MainInfo = (props) => {
    const {product = {}} = props;
    const {h1 = '', article = '', status = null, sticker = null} = product;

    return (
        <div className={`mainInfo`}>
            <h1 className={`h1 h1__product`}>
                {h1}
                <div className={`articleContainer`}>
                    <p className={`articleContainer__article`}>Артикул: {article}</p>
                    {/*<div className={`articleContainer__markers`}>*/}
                    {/*    {sticker && (*/}
                    {/*        <img src={sticker} alt={sticker} className={`sticker`} />*/}
                    {/*    )}*/}
                    {/*    /!*{product.new && (<div className={`new new__product`}>New</div>)}*!/*/}
                    {/*    /!*{hit && (<div className={`hit hit__product`}>Hit</div>)}*!/*/}
                    {/*</div>*/}
                </div>
            </h1>
            {!status ?
                <NotAvailable />
                :
                <AvailableComponent {...props} />
            }
        </div>
    );
}

export default MainInfo;
